import {useState, useEffect} from "react";
import {Settings, ChevronDown} from "lucide-react";
import { useNavigate, Link} from "react-router-dom";
import logo from "../assets/logos/zimble-logo.png";
import {useAppConfig} from "../context/AppConfigContext";

export default function Header() {
    const [showDropdown, setShowDropdown] = useState(false);
    const navigate = useNavigate();
    const {appConfig} = useAppConfig();
    const hasConfig = !!appConfig;

    const handleConfigClick = () => {
        navigate('/config-edit');
        setShowDropdown(false);
    };

    return (
        <header className="bg-gray-900 border-b border-gray-800">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center">
                        <Link to="/auth/load" >
                            <img
                                src={logo}
                                alt="Zimble Logo"
                                className="h-12 w-auto"
                            />
                        </Link>
                        <Link to="/auth/load" >
                            <span className="ml-10 text-white text-lg font-semibold">Dashboard</span>
                        </Link>
                    </div>

                    <div className="relative">
                        <button
                            onClick={() => setShowDropdown(!showDropdown)}
                            className="flex items-center px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-800 rounded-lg transition-colors"
                        >
                            <Settings size={20} className="mr-2"/>
                            <span>{hasConfig ? 'Your Config' : 'Setup Config'}</span>
                            <ChevronDown size={16} className="ml-2"/>
                        </button>

                        {showDropdown && (
                            <div
                                className="absolute right-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-lg shadow-lg z-50">
                                <button
                                    onClick={handleConfigClick}
                                    className="w-full text-left px-4 py-3 text-gray-300 hover:text-white hover:bg-gray-700 rounded-lg transition-colors"
                                >
                                    {hasConfig ? 'Edit Configuration' : 'Setup Configuration'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {showDropdown && (
                <div
                    className="fixed inset-0 z-40"
                    onClick={() => setShowDropdown(false)}
                />
            )}
        </header>
    );
}
